<template>
  <ul class="flex flex-col gap-100">
    <slot />
  </ul>
</template>
